// Static mock data for the Mentorship feature UI.
// Replace with real API data once the mentorship backend/service is available.

// SplashData.home.subcategories (set on login, refreshed by NavBar's splash
// query) carries the real category list — same source CreateMentorship.jsx
// uses for its Specialty dropdown — instead of a hardcoded mock list.
export function getSplashSubcategories() {
  try {
    const splash = JSON.parse(localStorage.getItem("SplashData"));
    const subs = splash?.home?.subcategories;
    return Array.isArray(subs) ? subs : [];
  } catch (e) {
    return [];
  }
}

// Filter chips need an "All" option prepended; id 0 is reserved for it
// since real category ids start at 1.
export function getMentorshipCategories() {
  return [{ id: 0, name: "All" }, ...getSplashSubcategories()];
}

// Resolves a filter chip's numeric id back to the category *name* string —
// that's what the mentor list API expects as `category_id`. Returns null
// for "All" (id 0 or unset), which means "send no category_id at all".
export function getCategoryNameById(id) {
  if (!id) return null;
  const match = getSplashSubcategories().find((sub) => sub.id === id);
  return match?.name || null;
}

export const mentorshipRequests = {
  mentor: {
    active: [
      {
        id: 1,
        name: "Dr. Juan Donate",
        image: "https://i.pravatar.cc/300?img=12",
        status: "Awaiting Mentor Response",
        statusCount: 3,
        meta: "Requested on Jul 22, 2026",
      },
      {
        id: 2,
        name: "Dr. María Gessa",
        image: "https://i.pravatar.cc/300?img=47",
        status: "Awaiting Mentor Response",
        meta: "Requested on Jul 22, 2026",
      },
      {
        id: 3,
        name: "Dr. Cosme Lavin",
        image: "https://i.pravatar.cc/300?img=33",
        status: "Sessions Confirmed",
        statusCount: 1,
        meta: "Jul 23, 2026 - 1:00 AM (GMT+2)",
      },
      {
        id: 4,
        name: "Dr. Cosme Lavin",
        image: "https://i.pravatar.cc/300?img=33",
        status: "Sessions Confirmed",
        statusCount: 1,
        meta: "Jul 23, 2026 - 1:00 AM (GMT+2)",
      },
      {
        id: 5,
        name: "Dr. Gonzalo Garcia",
        image: "https://i.pravatar.cc/300?img=51",
        status: "Mentorship in Progress",
        meta: "Started 10 mins ago",
      },
    ],
    completed: [
      {
        id: 101,
        name: "Dr. Maria Gessa",
        image: "https://i.pravatar.cc/300?img=51",
        duration: "1h 30m",
        completedDate: "Jul 23, 2026",
      },
      {
        id: 102,
        name: "Dr. Cosmo Levin",
        image: "https://i.pravatar.cc/300?img=51",
        duration: "2h 00m",
        completedDate: "Jul 20, 2026",
      },
      {
        id: 103,
        name: "Dr. Omar Farooq",
        image: "https://i.pravatar.cc/300?img=51",
        duration: "1h 15m",
        completedDate: "Jul 18, 2026",
      },
      {
        id: 104,
        name: "Dr. Zara Hussain",
        image: "https://i.pravatar.cc/300?img=51",
        duration: "45m",
        completedDate: "Jul 15, 2026",
      },
      {
        id: 105,
        name: "Dr. Imran Sheikh",
        image: "https://i.pravatar.cc/300?img=51",
        duration: "1h 00m",
        completedDate: "Jul 10, 2026",
      },
    ],
  },
  mentee: {
    active: [
      {
        id: 201,
        name: "Dr. Cosme Lavin Dapena",
        image: "https://i.pravatar.cc/300?img=33",
        status: "Awaiting Mentor Response",
        meta: "Requested on Jul 24, 2026",
      },
      {
        id: 202,
        name: "Dr. Gonzalo García de Oteyza",
        image: "https://i.pravatar.cc/300?img=51",
        status: "Sessions Confirmed",
        statusCount: 1,
        meta: "Jul 26, 2026 - 3:00 PM (GMT+2)",
      },
      {
        id: 203,
        name: "Dr. Gorka Martínez",
        image: "https://i.pravatar.cc/300?img=60",
        status: "Mentorship in Progress",
        meta: "Started 5 mins ago",
      },
    ],
    completed: [
      {
        id: 301,
        name: "Dr. Juan Donate",
        image: "https://i.pravatar.cc/300?img=12",
        duration: "1h 00m",
        completedDate: "Jul 19, 2026",
      },
      {
        id: 302,
        name: "Dr. María Gessa",
        image: "https://i.pravatar.cc/300?img=47",
        duration: "1h 30m",
        completedDate: "Jul 12, 2026",
      },
    ],
  },
};
